import { AccessTargetEnum } from './access-target.enum';

export enum UserRoleEnum {
	/** Гость */
	User = 'User',
	/** Водитель */
	Driver = 'Driver',
	/** Руководитель автопарка */
	DriverManager = 'DriverManager',
	/** Менеджер/Бухгалтер */
	Manager = 'Manager',
	/** Администратор*/
	Admin = 'Admin',
}

export function InitRole(accessTargetEnum: AccessTargetEnum[]) {
	if (
		!accessTargetEnum.includes(AccessTargetEnum.LinkedVehicle) &&
		!accessTargetEnum.includes(AccessTargetEnum.AllVehicle)
	) {
		return UserRoleEnum.User;
	} else if (!accessTargetEnum.includes(AccessTargetEnum.CreateAccountDriver)) {
		return UserRoleEnum.Driver;
	} else if (!accessTargetEnum.includes(AccessTargetEnum.CreateAccountDriverManager)) {
		return UserRoleEnum.DriverManager;
	} else if (!accessTargetEnum.includes(AccessTargetEnum.CreateAccountManager)) {
		return UserRoleEnum.Manager;
	} else return UserRoleEnum.Admin;
}

export const UserRoleName = new Map<UserRoleEnum, string>([
	[UserRoleEnum.User, 'Гость'],
	[UserRoleEnum.Driver, 'Водитель'],
	[UserRoleEnum.DriverManager, 'Руководитель автопарка'],
	[UserRoleEnum.Manager, 'Бухгалтер'],
	[UserRoleEnum.Admin, 'Администратор'],
]);
